import React from 'react';

const FourthStepWhatsappTemplate = ({ values }) => {
  // 'Session-Based Publication Opportunities and Conference Outcomes at [Conference Name]'
  const {
    client_name,
    paper_title,
    conference_name,
    // conference_date,
    conference_from_date,
    conference_to_date,
    conference_location,
    sdg_name_number,
    sdg_brif_explanation,
    registration_link,
    your_name,
    contact_details,
  } = values;
  return (
    <div>
      <p>{client_name ? `Dear ${client_name},` : ` Dear [Client Name],`}</p>

      <p>
        Congratulations on the acceptance of your paper titled "
        {paper_title ? paper_title : '[Paper Title]'}" for presentation at{' '}
        {conference_name ? conference_name : '[Conference Name]'}, scheduled on{' '}
        {conference_from_date && conference_to_date
          ? `${conference_from_date} - ${conference_to_date}`
          : `[Conference from and to Date]`}{' '}
        at {conference_location ? conference_location : '[Venue]'}.
      </p>

      <p>
        📌 Sustainable Development Focus Your research makes a meaningful
        contribution to the following United Nations Sustainable Development
        Goals (SDGs):
        <br /> • {sdg_name_number
          ? sdg_name_number
          : '[SDG Name & Number]'}:{' '}
        {sdg_brif_explanation
          ? sdg_brif_explanation
          : '[Brief explanation of how the paper aligns with this goal]'}
        .
      </p>
      <p>
        This session is carefully curated to advance research aligned with
        global sustainability objectives and foster insightful academic
        dialogue.
      </p>
      <p>
        To confirm your participation, please proceed with registration:{' '}
        {registration_link ? (
          <a href={registration_link}>{registration_link}</a>
        ) : (
          '[Insert Registration Link]'
        )}
      </p>
      <p>
        Should you require any assistance, feel free to reach out. We look
        forward to your contribution at the conference.
      </p>

      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default FourthStepWhatsappTemplate;
